import noop from 'lodash/noop';
import React from 'react';
import {
  Button,
  ButtonVariant,
  DropdownMenu,
  IconName,
  Tooltip,
} from '@usealloy/component-library';

export interface EllipsisMenuOption {
  id?: string;
  label: string;
  onClick: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  dataModal?: string;
  tooltip?: string;
  disabled?: boolean;
  dataDDActionName?: string;
}

export interface EllipsisMenuProps {
  'data-testid'?: string;
  id?: string;
  onBlur?: () => void;
  onClick?: () => void;
  onMouseOver?: () => void;
  onMouseOut?: () => void;
  options: EllipsisMenuOption[];
}

const defaultProps: Pick<
EllipsisMenuProps, 'onBlur' | 'onClick' | 'onMouseOver' | 'onMouseOut'
> = {
  onBlur: noop,
  onClick: noop,
  onMouseOver: noop,
  onMouseOut: noop,
};

export default function EllipsisMenu({
  'data-testid': testId, onBlur, options, ...rest
}: EllipsisMenuProps) {
  return (
    <DropdownMenu
      align="end"
      trigger={(
        <Button
          data-testid={testId}
          icon={IconName.More}
          variant={ButtonVariant.tertiary}
          onBlur={onBlur}
          {...rest}
        />
      )}
    >
      {options.map(option => {
        const dropdownItem = (
          <DropdownMenu.Item
            onClick={!option.disabled ? option.onClick : undefined}
            key={option.label}
            disabled={option.disabled}
            data-modal={option.dataModal}
            data-dd-action-name={option.dataDDActionName}
          >
            {option.label}
          </DropdownMenu.Item>
        );

        return option.tooltip ? (
          <Tooltip
            content={option.tooltip}
            align="center"
            skipDelayDuration={0}
          >
            {dropdownItem}
          </Tooltip>
        ) : (
          dropdownItem
        );
      })}
    </DropdownMenu>
  );
}

EllipsisMenu.defaultProps = defaultProps;
